import useJsonApi from "lib/useJsonApi.js";

function useAppointment(appointmentUuid) {
  return useJsonApi({
    url: `/api/appointment/${encodeURIComponent(appointmentUuid)}`,
  });
}

export default useAppointment;
